export function initVehicleConfigurator() {
  return [
    ...document.querySelectorAll(".b-vehicle-configurator:not(.-initialized)"),
  ].map((el) => new VehicleConfigurator(el));
}

export class VehicleConfigurator {
  _dom = {
    wrapper: null,
    openConfiguratorButton: null,
    openConsultationButton: null,
    body: null,
    modal: null,
    modalCloseIcon: null,
    fluentFormStepContainer: null,
    fluentFormFirstStepContainerButton: null,
    fluentFormSteps: null,
    modalCloseSection: null,
    modalCloseSectionCloseBtn: null,
    modalCloseSectionReturn: null,
    services: null,
    runtimeMonthsElements: [],
    kilometeragePAElements: [],
    deliveryInputs: [],
  };

  _state = {
    defaultRawPrice: null,
    defaultTaxedPrice: null,
    topDeal: null,
    runtimeInMonths: null,
    kilometeragePA: null,
    additionalEquipment: [],
    langCode: null,
    rawPrice: null,
    taxedPrice: null,
    postId: null,
    selections: {
      additionalEquipment: [],
    },
    salesCalculationData: [],
  };

  _config = {
    taxValue: 1.19,
    moneyFormat: "de-DE",
    freeCode: "Web_Anfrage_blank",
    deliveryServiceCode: "LODI-AUT",
    returnServiceCode: "ABHO-AUT",
  };

  constructor(element) {
    this._dom.body = document.querySelector("body");

    this._dom.wrapper = element;
    this._dom.wrapper.classList.add("-initialized");

    // Assigning the state values
    this._state.topDeal = this._dom.wrapper.dataset.topDeal === "1";
    this.setRuntimeInMonths(this._dom.wrapper.dataset.leasingTime);
    this.setKilometeragePA(this._dom.wrapper.dataset.mileage);
    this._state.langCode = document.documentElement.lang.substring(0, 2);
    this._state.postId = this._dom.wrapper.dataset.postId;
    this._state.defaultRawPrice = parseFloat(
      this._dom.wrapper.dataset.rawPrice
    );
    this._state.defaultTaxedPrice = parseFloat(
      this._dom.wrapper.dataset.taxedPrice
    );

    // Set the language code in the input field
    const languageCodeElement = this._dom.wrapper.querySelector(
      "input[name='languageCode']"
    );
    if (languageCodeElement) {
      languageCodeElement.value = this._state.langCode;
    }

    // Assigning the DOM elements
    this._dom.services = this._dom.wrapper.querySelector(".vc_services");

    this._dom.openConfiguratorButton = this._dom.body.querySelector(
      "#vehicle-configurator"
    );
    this._dom.openConsultationButton = this._dom.body.querySelector(
      "#vehicle-consultation"
    );

    this._dom.modal = this._dom.wrapper.querySelector(
      ".b-vehicle-configurator__inner"
    );

    this._dom.modalCloseIcon = this._dom.body.querySelector(
      ".b-vehicle-configurator__close-icon"
    );

    this._dom.fluentFormStepContainer = this._dom.wrapper.querySelector(
      ".b-vehicle-configurator__form .fluentform .fluentform-step:first-of-type"
    );
    this._dom.fluentFormFirstStepContainerButton =
      this._dom.wrapper.querySelector(
        ".b-vehicle-configurator__form .fluentform .fluentform-step:first-of-type .ff-btn-next"
      );

    this._dom.fluentFormSteps = this._dom.wrapper.querySelectorAll(
      ".b-vehicle-configurator__form .fluentform .fluentform-step"
    );

    this._dom.modalCloseSection = this._dom.wrapper.querySelector(
      ".b-vehicle-configurator__cancel"
    );
    this._dom.modalCloseIcon = this._dom.wrapper.querySelector(
      ".b-vehicle-configurator__close-icon"
    );
    this._dom.modalCloseSectionCloseBtn =
      this._dom.modalCloseSection.querySelector(".-close-configurator");
    this._dom.modalCloseSectionReturn =
      this._dom.modalCloseSection.querySelector(".-close-cancel");

    this._dom.runtimeMonthsElements = Array.from(
      this._dom.wrapper.querySelectorAll(".runtimeInMonths input")
    );
    this._dom.kilometeragePAElements = Array.from(
      this._dom.wrapper.querySelectorAll(".kilometeragePA input")
    );
    this._dom.deliveryInputs = Array.from(
      this._dom.wrapper.querySelectorAll('[name="deliveryService"]')
    );

    this.init();
  }

  setRuntimeInMonths(v) {
    const minValue = 1; // Months
    const maxValue = 24;
    let value = v !== null ? parseInt(v) : minValue;
    value = Number.isInteger(value)
      ? Math.min(Math.max(parseInt(value), minValue), maxValue)
      : minValue;

    this._state.runtimeInMonths = value;
  }

  setKilometeragePA(v) {
    const minValue = 1000; // Kilometers
    const maxValue = 4500;
    let value = v !== null ? parseInt(v) : minValue;
    value = Number.isInteger(value)
      ? Math.min(Math.max(parseInt(value), minValue), maxValue)
      : minValue;

    this._state.kilometeragePA = value;
  }

  init() {
    this.initRadioInputs();

    // just for early testing
    if (this._dom.openConfiguratorButton) {
      this._dom.openConfiguratorButton.addEventListener("click", () => {
        this._dom.modal.classList.add("-active-modal");
        this._dom.modal.classList.add("-configurator-modal");
        this._dom.body.style.overflow = "hidden";
        setTimeout(() => {
          this._dom.modal.classList.add("-start");
        }, 100);

        if (!this._state.topDeal) {
          this.handleUpdatePrice();
        } else {
          this.handleServices();
        }

        this.submitButtonPosition();

        if (window.innerWidth < 1024) {
          if (!this._dom.modal.classList.contains("-start-step-2")) {
            this._dom.fluentFormStepContainer.addEventListener(
              "scroll",
              (event) => {
                this.handleStepScroll(event);
              }
            );
            this._dom.fluentFormFirstStepContainerButton.addEventListener(
              "click",
              (event) => {
                this.handleStepClick(event);
              }
            );
          }
        }
      });
    }

    if (this._dom.openConsultationButton) {
      this._dom.openConsultationButton.addEventListener("click", () => {
        this._dom.modal.classList.add("-active-modal");
        this._dom.modal.classList.add("-start");
        this._dom.modal.classList.add("-consultation-modal");
        this._dom.body.style.overflow = "hidden";
      });
    }

    //open closing section
    if (this._dom.modalCloseIcon) {
      this._dom.modalCloseIcon.addEventListener("click", () => {
        if (this._dom.modal.classList.contains("-active-modal")) {
          this._dom.modalCloseSection.classList.add("-active");
        }
      });
      if (this._dom.modalCloseSectionCloseBtn) {
        this._dom.modalCloseSectionCloseBtn.addEventListener("click", () => {
          this._dom.modal.classList.remove("-active-modal");
          this._dom.modal.classList.remove("-configurator-modal");
          this._dom.modal.classList.remove("-consultation-modal");
          this._dom.body.style.overflow = "unset";
          this._dom.body.style.removeProperty("overflow");
          this._dom.modalCloseSection.classList.remove("-active");
        });
      }
    }

    if (this._dom.modalCloseSectionReturn) {
      this._dom.modalCloseSectionReturn.addEventListener("click", () => {
        this._dom.modalCloseSection.classList.remove("-active");
      });
    }

    const accordions = document.querySelectorAll(".ff-custom_html.-accordion");

    accordions.forEach((accordion) => {
      const heading = accordion.querySelector("p");

      heading.addEventListener("click", () => {
        accordion.classList.toggle("open");
        heading.classList.toggle("active");
      });
    });

    const dropdowns = document.querySelectorAll(".ff-el-input--content select");

    dropdowns.forEach((dropdown) => {
      // Create custom dropdown wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "custom-dropdown-wrapper";

      // Create selected item display
      const selectedDisplay = document.createElement("div");
      selectedDisplay.className = "custom-dropdown-selected";

      // Create options list
      const optionsList = document.createElement("ul");
      optionsList.className = "custom-dropdown-options";

      // Hide original select
      dropdown.style.display = "none";

      // Populate selected display and options list
      const initialSelectedOption =
        dropdown.querySelector("option:checked") ||
        dropdown.querySelector("option");
      selectedDisplay.textContent = initialSelectedOption.textContent;

      // Create options
      Array.from(dropdown.options).forEach((option, index) => {
        const listItem = document.createElement("li");
        listItem.textContent = option.textContent;
        listItem.setAttribute("data-value", option.value);

        listItem.addEventListener("click", () => {
          // Update original select
          dropdown.value = option.value;

          // Update selected display
          selectedDisplay.textContent = option.textContent;

          // Trigger change event on original select
          const event = new Event("change", { bubbles: true });
          dropdown.dispatchEvent(event);

          // Close dropdown
          wrapper.classList.remove("open");
        });

        optionsList.appendChild(listItem);
      });

      // Toggle dropdown
      selectedDisplay.addEventListener("click", () => {
        wrapper.classList.toggle("open");
      });

      // Close dropdown when clicking outside
      document.addEventListener("click", (event) => {
        if (!wrapper.contains(event.target)) {
          wrapper.classList.remove("open");
        }
      });

      // Assemble wrapper
      wrapper.appendChild(selectedDisplay);
      wrapper.appendChild(optionsList);

      // Insert wrapper before original select
      dropdown.parentNode.insertBefore(wrapper, dropdown);
    });
  }

  handleStepScroll(event) {
    const scrollPosition = this._dom.fluentFormStepContainer.scrollTop;
    if (scrollPosition > 200) {
      this._dom.modal.classList.add("-start-step-2");
    }
  }

  handleStepClick(event) {
    this._dom.modal.classList.add("-start-step-2");
  }

  calcServicesPrice(onlyTransport = false) {
    let additionalCosts = 0;

    if (this._state.salesCalculationData.length > 0) {
      this._state.salesCalculationData.forEach((item) => {
        const matchedEquipment =
          this._state.selections.additionalEquipment.find(
            (eq) => item["Calculation Type Code"] === eq
          );

        if (
          onlyTransport &&
          (item["Calculation Type Code"] === this._config.deliveryServiceCode ||
            item["Calculation Type Code"] === this._config.returnServiceCode)
        ) {
          additionalCosts += parseFloat(
            item["Monthly Value"] || item["Monthly Rate"] || 0
          );
        } else if (
          !onlyTransport &&
          matchedEquipment &&
          item["Description 2"] !== this._config.freeCode &&
          item["Calculation Type Code"] !== this._config.deliveryServiceCode &&
          item["Calculation Type Code"] !== this._config.returnServiceCode
        ) {
          additionalCosts += parseFloat(
            item["Monthly Value"] || item["Monthly Rate"] || 0
          );
        }
      });
    }

    return additionalCosts;
  }

  calcTotalPrice() {
    let totalPrice = this._state.topDeal
      ? this._state.defaultRawPrice
      : this._state.rawPrice;
    const additionalCosts = this.calcServicesPrice();

    totalPrice = parseFloat(totalPrice) + parseFloat(additionalCosts);

    return {
      totalPrice: totalPrice,
      additionalCosts: additionalCosts,
    };
  }

  updatePricesDisplayed() {
    const priceDetails = this.calcTotalPrice();

    // Update price display
    const priceElements = this._dom.wrapper.querySelectorAll(
      ".b-vehicle-configurator__price--wrapper"
    );

    const totalPrice = priceDetails.totalPrice;

    priceElements.forEach((el) => {
      const priceElement = el.querySelector(
        ".b-vehicle-configurator__price .-vehicle-price .-price"
      );
      priceElement.innerHTML = `${totalPrice.toFixed(2).replace(".", ",")} €`;

      const rentalRateElement = document.querySelector(
        "input[name='rentalRate']"
      );
      if (rentalRateElement) {
        rentalRateElement.value = totalPrice.toFixed(2);
      }

      const taxPriceElement = el.querySelector(
        ".b-vehicle-configurator__price .-vehicle-price .-taxprice"
      );
      const originalString = taxPriceElement.innerHTML;
      const priceMatch = originalString.match(/(\d{1,3}(?:\.\d{3})*,\d{2})/);

      if (priceMatch) {
        const updatedPrice = this.displayPrice(
          totalPrice * this._config.taxValue
        );
        taxPriceElement.innerHTML = originalString.replace(
          priceMatch[0],
          updatedPrice
        );
      }
    });
  }

  updateServicesDisplayed() {
    const deliveryServiceObj = this._state.salesCalculationData.find(
      (item) =>
        item["Calculation Type Code"] === this._config.deliveryServiceCode
    );
    const returnServiceObj = this._state.salesCalculationData.find(
      (item) => item["Calculation Type Code"] === this._config.returnServiceCode
    );

    const deliveryServiceinput = this._dom.wrapper.querySelector(
      'input[name="deliveryService"][value="true"]'
    );
    const nextSpan = deliveryServiceinput.nextElementSibling;

    const transportTextValue =
      window.appConfig?.vehicleConfiguration.transportService
        .replace(
          "{deliveryServicePrice}",
          this.displayPrice(
            deliveryServiceObj["Monthly Value"] || item["Monthly Rate"]
          )
        )
        .replace(
          "{returnServicePrice}",
          this.displayPrice(
            returnServiceObj["Monthly Value"] || item["Monthly Rate"]
          )
        );
    let transportTextNode = nextSpan.querySelector(".-transport-desc");

    if (!transportTextNode) {
      transportTextNode = document.createElement("span");
      transportTextNode.classList.add("-transport-desc");
      nextSpan.appendChild(transportTextNode);
    }

    transportTextNode.innerHTML = transportTextValue;

    const noMonthlySurchargeText =
      this._dom.services.dataset.noMonthlySurcharge;
    const monthlySurchargeText = this._dom.services.dataset.monthlySurcharge;
    const content = this._dom.services.querySelector(".ff-el-input--content");

    content.innerHTML = "";

    const defaultHtml = this._dom.services.querySelector(
      ".ff-el-form-check.-hidden"
    );

    this._state.salesCalculationData.forEach((item) => {
      if (
        item["Calculation Type Code"] === this._config.deliveryServiceCode ||
        item["Calculation Type Code"] === this._config.returnServiceCode
      ) {
        return;
      }

      const clonedHtml = defaultHtml.cloneNode(true);
      clonedHtml.classList.remove("-hidden");

      const label = clonedHtml.querySelector("label");
      const input = clonedHtml.querySelector("input");
      const desc = clonedHtml.querySelector("label span");

      label.setAttribute("for", item["Calculation Type Code"]);
      input.setAttribute("id", item["Calculation Type Code"]);
      input.setAttribute("name", "additionalEquipment[]");
      input.setAttribute("data-name", "additionalEquipment");
      input.setAttribute("value", item["Calculation Type Code"]);

      let html = "";

      if (
        this._state.langCode !== "de" &&
        item["Web Description English"] !== ""
      ) {
        html = item["Web Description English"];
      } else if (item["Web Description"] !== "") {
        html = item["Web Description"];
      } else {
        html = item["Description"];
      }

      if (item["Description 2"] === this._config.freeCode) {
        html += `<span>${noMonthlySurchargeText}</span>`;
      } else {
        const price = item["Monthly Value"] || item["Monthly Rate"];
        const taxprice = price * this._config.taxValue;

        const desc = monthlySurchargeText
          .replace("{price}", this.displayPrice(price))
          .replace("{taxprice}", this.displayPrice(taxprice));
        if (
          this._state.langCode !== "de" &&
          item["Web Description Details Engl."] !== ""
        ) {
          html += `<span>${item["Web Description Details Engl."]}</span>`;
        } else if (item["Web Description Details"] !== "") {
          html += `<span>${item["Web Description Details"]}</span>`;
        }
        html += `<span>${desc}</span>`;
      }

      desc.innerHTML = html;

      content.appendChild(clonedHtml);

      clonedHtml.addEventListener("change", (event) =>
        this.handleServiceChange(event.target)
      );
    });
  }

  handleServiceChange(input) {
    let checked = input.checked;

    if (
      checked &&
      !this._state.selections.additionalEquipment.includes(
        input.getAttribute("value")
      )
    ) {
      this._state.selections.additionalEquipment.push(
        input.getAttribute("value")
      );
    } else {
      this._state.selections.additionalEquipment =
        this._state.selections.additionalEquipment.filter(
          (item) => item !== input.getAttribute("value")
        );
    }

    this.updatePricesDisplayed();
  }

  handleServices() {
    const runtimeInMonths = parseInt(this._state.runtimeInMonths);
    const kilometeragePA = parseInt(this._state.kilometeragePA);
    const rentalRate = parseFloat(
      this._state.topDeal ? this._state.defaultRawPrice : this._state.rawPrice
    );

    if (isNaN(runtimeInMonths) || isNaN(kilometeragePA) || isNaN(rentalRate)) {
      console.error("Invalid input values for services calculation");
      return;
    }

    const url = `/wp-json/mhc-salesforce/v1/vehicle/${this._state.postId}/services`;
    const payload = {
      postId: this._state.postId,
      runtimeInMonths: runtimeInMonths,
      kilometeragePA: kilometeragePA,
      rentalRate: rentalRate,
      languageCode: this._state.langCode,
    };
    const queryParams = this.toQueryString(payload);

    fetch(`${url}?${queryParams}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        this._state.salesCalculationData = response.data["Sales Calculation"];

        this.updateServicesDisplayed();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  handleUpdatePrice() {
    this.setRuntimeInMonths(
      this._dom.runtimeMonthsElements.find((el) => el.checked)?.value ?? null
    );
    this.setKilometeragePA(
      this._dom.kilometeragePAElements.find((el) => el.checked)?.value ?? null
    );

    if (!this._state.runtimeInMonths || !this._state.kilometeragePA) {
      throw new Error("Invalid input values");
    }

    const runtimeInMonths = parseInt(this._state.runtimeInMonths);
    const kilometeragePA = parseInt(this._state.kilometeragePA);

    if (isNaN(runtimeInMonths) || isNaN(kilometeragePA)) {
      throw new Error("Invalid input values");
    }

    const url = `/wp-json/mhc-salesforce/v1/vehicle/${this._state.postId}/prices`;

    const payload = {
      postId: this._state.postId,
      runtimeInMonths: runtimeInMonths,
      kilometeragePA: kilometeragePA,
    };

    const queryParams = this.toQueryString(payload);

    fetch(`${url}?${queryParams}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.data?.raw_price || !response.data?.taxed_price) {
          console.error("Error:", response);
          Toastify({
            text: window.appConfig?.errorToastMessage,
            className: "error",
            duration: 5000,
            gravity: "bottom",
            position: "right",
          }).showToast();
          return;
        }

        this._state.rawPrice = response.data.raw_price;
        this._state.taxedPrice = response.data.taxed_price;

        this.updatePricesDisplayed();
        this.handleServices();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  toQueryString(payload) {
    let queryString = "";
    for (let key in payload) {
      if (payload.hasOwnProperty(key)) {
        if (queryString.length > 0) {
          // Separate query parameters with '&'
          queryString += "&";
        }
        queryString +=
          encodeURIComponent(key) + "=" + encodeURIComponent(payload[key]);
      }
    }
    return queryString;
  }

  submitButtonPosition() {
    this._dom.fluentFormSteps.forEach((step) => {
      const footers = step.querySelectorAll(".b-vehicle-configurator__footer");

      footers.forEach((footer) => {
        const parentElement = footer.parentElement;
        const buttons = parentElement.querySelectorAll("button");

        buttons.forEach((button) => {
          footer.appendChild(button.parentElement);
        });
        // Move buttons to footer
        buttons.forEach((button) => {
          const buttonContainer =
            button.closest(".ff-btn-container") || button.parentElement;
          footer.appendChild(buttonContainer);
        });

        // Remove empty ff-t-cell divs
        const emptyCells = footer.querySelectorAll(".ff-t-cell");
        emptyCells.forEach((cell) => {
          if (cell.children.length === 0) {
            cell.remove();
          }
        });

        // Only for desktop, move price wrapper to footer
        if (window.innerWidth >= 1024) {
          const priceWrappers = parentElement.querySelectorAll(
            ".b-vehicle-configurator__price--wrapper"
          );
          priceWrappers.forEach((priceWrapper) => {
            footer.appendChild(priceWrapper);
          });
        }
      });
    });
  }

  displayPrice(number) {
    return new Intl.NumberFormat(this._config.moneyFormat, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  }

  initRadioInputs() {
    this._dom.runtimeMonthsElements.forEach((el) => {
      const value = parseInt(el.value);
      // Check default values, and disable if top deal
      if (this._state.runtimeInMonths) {
        el.removeAttribute("checked");
        if (value === this._state.runtimeInMonths) {
          el.setAttribute("checked", "checked");
        } else if (this._state.topDeal) {
          el.setAttribute("disabled", "disabled");
          el.closest(".ff-el-form-check").classList.add("-disabled");
        }
      }

      // runtimeInMonths in checkbox input, check if changed and then fetch data
      el.addEventListener("click", () => {
        if (el.getAttribute("disabled") === "disabled") {
          return;
        }

        this.handleUpdatePrice();
        return value;
      });
    });

    this._dom.kilometeragePAElements.forEach((el) => {
      const value = parseInt(el.value);

      // Check default values, and disable if top deal
      if (this._state.kilometeragePA) {
        el.removeAttribute("checked");
        if (value === this._state.kilometeragePA) {
          el.setAttribute("checked", "checked");
        } else if (this._state.topDeal) {
          el.setAttribute("disabled", "disabled");
          el.closest(".ff-el-form-check").classList.add("-disabled");
        }
      }

      // kilometeragePA in checkbox input, check if changed and then fetch data
      el.addEventListener("click", () => {
        if (el.getAttribute("disabled") === "disabled") {
          return;
        }

        this.handleUpdatePrice();
        return value;
      });
    });

    // delivery inputs, check if changed and then fetch data
    this._dom.deliveryInputs.forEach((el) => {
      el.addEventListener("click", () => {
        const value = el.checked && el.value === "true";

        if (value) {
          this._state.selections.additionalEquipment.push(
            this._config.deliveryServiceCode,
            this._config.returnServiceCode
          );
        } else {
          this._state.selections.additionalEquipment =
            this._state.selections.additionalEquipment.filter(
              (item) =>
                item !== this._config.deliveryServiceCode &&
                item !== this._config.returnServiceCode
            );
        }

        return el.value;
      });
    });
  }
}
